<template>
  <header class="header">
    <div><module-button 
      v-if="!hideDisclaimerButton" 
      @click.native="selectActionlanguage" 
      button="primary" 
      size="s"
      :class="(isBurgerClick && menuActive) ? 'language-mobile' : 'language'">
      <div class="language__icon">
        <img class="about__img hide-below-medium" :src="language" alt="ALT">
      </div>
      Language
    </module-button>

      <module-modal :modal="modalData" v-show="selectLanguage" @close="closeDisclaimer">

        <template slot="modal-footer">
          <module-button @click.native="languageAgreed" button="primary" size="s">
            Accept
          </module-button>

          <module-button @click.native="cancled" button="secondary" size="s">
            Cancel
          </module-button>
        </template>
      </module-modal>
    <div v-show="hideDisclaimerButton" id="google_translate_element_position" /></div>
    <div 
      :style="{ 'background': org.custom_color1 == null ? '': org.custom_color1 }" 
      :class="['nav-main-row', 'fwc-row', 'a-center']" >
      <div class="nav-header-list-item">                                  
        <span class="icon-phone-light"><img 
          :style="{ 'fill': org.custom_color1 == null ? '': org.custom_color1}"
          :src="iconPhoneLight" 
          alt="Login" >
        </span>                             
        <div class="nav-header-list-desktop">
          <li class="nav-header-list-desktop__emergency">
            <p class="header-text">Emergency :</p>
            <a href="tel:911" class="header-num">911</a>
          </li>
          <li class="nav-header-list-desktop__emergency">
            <p class="header-text">Suicide :</p>
            <a href="tel:988" class="header-num">988</a>
          </li>
          <li class="nav-header-list-desktop__emergency">
            <p class="header-text">EAP support call/text :</p>
            <a class="link" :href="`tel:${number}`"><b>{{ number }}</b></a>
          </li>
        </div>
      </div>
    </div>
    <div 
      :style="{ 'border-top-color': org.custom_color1 == null ? '': org.custom_color1 }">
      <div class="header__inner">
        <span 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          fullHeader
          :class="['header__toggle', { 'header__toggle--active': menuActive }]"
          @click="toggleMenu()"
        />
        <div
          :class="[
            'header__wrapper',
            { 'header__wrapper--active': menuActive },
            { 'header__wrapper--full': !fullHeader }
          ]"
        >
          <div class="header__branding">
            <!-- Logo -->
            <router-link
              :to="{ name: `home` }"
              :class="[
                'header__logo',
                { 'header__logo--custom': org.glyph && org.glyph.full_size }
              ]"
            >
              <img
                v-if="org.glyph && org.glyph.full_size"
                :width="`${org.glyph_width}px`"
                :height="`${org.glyph_height}px`"
                :src="org && org.glyph && org.glyph.full_size"
                :alt="org && org.program_name"
              >
              <module-logo v-else />
            </router-link>

          </div>

          <div
            :class="[
              `navigation`,
              {
                'navigation--open': menuActive,
                //'hide-below-medium': fullHeader
              }
            ]"
          ><div>
            <div>
              <div v-if="menuActive" class="burgerclose">
                <button @click="toggleMenu"><img class="burgerclose__img " :src="xIcon" alt="Xicon"></button>
                <!-- Menu content here -->
              </div>
            </div>
            <div :class="(isBurgerClick && menuActive) ? 'activebg' : ''">
              <ul fullHeader class="navigation__inner">
              
                <router-link
                  v-if="isAuthenticated"
                  :class="['navigation__item', 'navigation__item--' + 'messages']"
                  :to="{ name: 'messages' }"
                  tag="li"
                  @click.native="menuActive = false, isBurgerClick = false"
                
                >
                  <a
                    :class="[
                      'navigation__link',
                      'link link--underline',
                      'c-hedlink',
                      {
                        'router-link-active': 'messages' === $route.name
                      }
                    ]"
                  >
                    <span 
                      class="navigation__label"
                      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }">Messages
                      <i v-show="unreadCount" class="navigation__count">({{
                        unreadCount
                      }})</i>
                    </span>
                  </a>
                </router-link>

                <router-link
                  v-if="isAuthenticated"
                  :class="['navigation__item', 'navigation__item--' + 'documents']"
                  :to="{ name: 'documents' }"
                  tag="li"
                  @click.native="menuActive = false, isBurgerClick = false"
                >
                  <a
                    :class="[
                      'navigation__link',
                      'link link--underline',
                      'c-hedlink',
                      {
                        'router-link-active': 'documents' === $route.name
                      }
                    ]"
                  >
                    <span 
                      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
                      class="navigation__label">Documents</span>
                  </a>
                </router-link>
                <router-link
                  v-if="isAuthenticated"
                  :class="['navigation__item', 'navigation__item--' + 'appointments']"
                  :to="{ name: 'appointments' }"
                  tag="li"
                  @click.native="menuActive = false, isBurgerClick = false"
                >
                  <a
                    :class="[
                      'navigation__link',
                      'link link--underline',
                      'c-hedlink',
                      {
                        'router-link-active': 'appointments' === $route.name
                      }
                    ]"
                  >
                    <span 
                      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
                      class="navigation__label">Appointments</span>
                  </a>
                </router-link>
            
                <span 
                  v-show="isAuthenticated" 
                  class="header__divider" 
                  v-if="org.username !== 'is_root_org'" 
                  :style="{ 'background': org.custom_color1 == null ? '': org.custom_color1 }"/>

                <router-link
                  v-if="org && org.username && org.username !== 'is_root_org'"
                  :class="['navigation__item', 'navigation__item--' + 'about']"
                  :to="{ name: 'about' }"
                  tag="li"
                  @click.native="menuActive = false, isBurgerClick = false"
                >
                  <a
                    :class="[
                      'navigation__link',
                      'link link--underline',
                      {
                        'router-link-active': 'about' === $route.name
                      }
                    ]"
                  >
                    <span 
                      class="navigation__label, c-accent"
                      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
                    >What's {{ org.program_name || "Carelon Wellbeing" }}?</span
                    >
                  </a>
                </router-link>

                <!-- Dynamic -->
                <router-link
                  v-for="route in menus"
                  :key="route.path"
                  :class="['navigation__item', 'navigation__item--' + route.path]"
                  :to="{ name: route.path }"
                  tag="li"
                  @click.native="menuActive = false, isBurgerClick = false"
                >
                  <a
                    v-if="org && org.username"
                    :class="[
                      'navigation__link',
                      'link link--underline',
                      'c-accent',
                      {
                        'router-link-active': route.path === $route.name
                      }
                    ]"
                  >
                    <span 
                      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
                      class="navigation__label">{{ route.name }}</span>
                  </a>
                </router-link> 
              </ul>
            </div>   
          </div>
          </div>
        </div>
        <div class="header__user">
          <div v-if="isAuthenticated" class="header__fullprofile">
            <div class="profilepic">
              <img 
                :style="{ 'fill': org.custom_color1 == null ? '': org.custom_color1 }"
                :src="profilePicture" 
                alt="profilePicture" 
              >
            </div>
            <div class="Test">
              <router-link 
                :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
                :class="['h2', 'profilename', 'navigation__item--profile']"
            
                :to="{ name: 'profile' }"
                tag="li"
                @click.native="menuActive = false, isBurgerClick = false"
              >
                <a
                  :class="[
                    'navigation__link',
                    'link link--underline',
                    'profile',
                    {
                      'router-link-active': 'profile' === $route.name
                    }
                  ]"
                >
                  <span 
                    :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
                    class="navigation__label"
                  >
                    {{ firstName }}
                  </span>
                </a>
                
              </router-link>
              <router-link
                v-if="isAuthenticated"
                :class="[{ mt0: !isAuthenticated }]"
                :to="'/log-out'"
              >
                <div class="header__logout">
                  <span
                    :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
                    class="navigation__label navigation__link logoutnav link link--underline"
                  >
                    Log out
                  </span><img 
                    :style="{ 'fill': org.custom_color1 == null ? '': org.custom_color1}"
                    :src="logoutIcon" 
                    alt="Logout" ></div>
              </router-link>
            </div>
          </div>
          <div><template v-if="org && org.username && org.username !== 'is_root_org'">
            <router-link
              v-if="!isAuthenticated && !org.dfd_client"
              :class="['header__logout', { mt0: !isAuthenticated }]"
              :to="'/log-in'"
            >
              <img 
                class="header__login__img"
                :style="{ 'fill': org.custom_color1 == null ? '': org.custom_color1}"
                :src="loginIcon" 
                alt="Login" >
              <span
                :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
                class="navigation__label navigation__link link link--underline"
              >
                Log in
              </span>
            </router-link>
            <a
              v-if="!isAuthenticated && org.dfd_client"
              :class="['header__logout', { mt0: !isAuthenticated }]"
              :href="`${sanitizeUrl(org.dfd_redirect_url)}/sign-in?cw=true`"
            >
              <img 
                :style="{ 'fill': org.custom_color1 == null ? '': org.custom_color1}"
                :src="loginIcon" 
                alt="Login" >
              <span
                :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
                class="navigation__label navigation__link logoutnav link link--underline"
              >
                Log in
              </span>
            </a> 
          </template>
          </div>
        </div>
      </div>
    </div> 
    
  </header>
  
</template>

<script>
// Vuex
import { mapGetters, mapState, mapActions } from 'vuex';
import arrow from 'images/icons/arrow-right.svg';

import phone from 'utils/phone';

import logoutIcon from 'images/icons/logout.svg';
import loginIcon from 'images/icons/login.svg';
import iconPhoneLight from 'images/icons/phone-icon-white.png';
import profilePicture from 'images/icons/default-profile-picture.svg';
import language from '../assets/images/icons/language.svg';
import xIcon from '../assets/images/icons/x-icon.svg';
// Models
import ModuleModal from 'components/Modal';
import Authed from 'models/global/Authed';
import noAuthed from 'models/global/noAuthed';

import { titleCase } from 'utils/titleCase';
import Button from './Button.vue';

import DOMPurify from 'dompurify';

// Export
export default {
  name: 'ui-header',
  components: { Button,
    ModuleModal,
  },

  data() {
    return {
      icon: arrow,
      menuActive: false,
      isBurgerClick:false,
      getMenu: [],
      logoutIcon,
      loginIcon,
      iconPhoneLight,
      xIcon,
      profilePicture,
      isMobile: false,
      showMessage:false,
      language,
      disclaimerModal: false,
      hideDisclaimerButton: false,
      getLocalStoreLocalStoreUp: true,
      modalData: {
        title: 'Automatic translation disclaimer',
        copy: 'Carelon Wellbeing provides automatic translation into multiple languages, courtesy of Google Translate. This tool is provided for your convenience only. The English language version is considered the most accurate, and in the event of a discrepancy between the translations, the English version will prevail. This translation tool is not controlled by Carelon Wellbeing, and the Carelon Wellbeing Privacy Statement will not apply. Please read Google’s privacy statement. If you want Google to translate the Carelon Wellbeing website, select a language.',
      },
    };
  },

  // Data
  computed: {
    ...mapGetters('app', ['org']),
    ...mapGetters('messaging', ['unreadCount']),
    ...mapGetters('appointment', ['patientFname']),

    ...mapState('app', ['landingPopUp', 'selectLanguage']),
    page() {
      return this.$store.state.app.page;
    },
    loading() {
      return this.$store.state.app.state.loading;
    },

    ...mapGetters('auth', ['isAuthenticated']),

    number() {
      return phone(this.org.phone);
    },

    getHelp() {
      if (this.org && this.org.phone) {
        return `Need Help? Call <a href="tel: ${this.number}">${this.number}</a>`;
      }
    },

    menus() {
      if (this.isAuthenticated) {
        return Authed;
      }

      if (this.org.username === 'is_root_org') {
        return [];
      }

      return noAuthed;
    },

    firstName() {
      if (this.isAuthenticated) {
        return titleCase(this.patientFname);
      }

    },

    fullHeader() {
      return this.$route.meta.fullHeader;
    },
  },

  methods: {

    ...mapActions('app', [
      'setselectLanguage',
      'setOffLoadPopUp',
    ]),


    toggleMenu() {
      this.menuActive = !this.menuActive;
      this.isBurgerClick = !this.isBurgerClick;
    },
    closeMenu() {
      this.menuActive = false;
      this.isBurgerClick = false;
    },

    showMessagepop() {
      this.showMessage = !this.showMessage;
    },
    sanitizeUrl(url) {
      return DOMPurify.sanitize(url, { ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|[^a-z]|[a-z+.\\-]+(?:[^a-z+.\-:]|$))/i });
    },

    languageAgreed() {
      this.setselectLanguage(false);
      this.hideDisclaimerButton = true;
    },
    cancled() {
      this.setselectLanguage(false);
    },
    selectActionlanguage() {
      this.setselectLanguage(true);
      this.setOffLoadPopUp();
    },
    closeDisclaimer() {
      this.setselectLanguage(false);
    },
  },

  mounted() {
    localStorage.setItem('logOut', 'false');
    const mediaQuery = window.matchMedia('(max-width: 768px');
    this.isMobile = mediaQuery.matches;
    mediaQuery.addEventListener('change', (event) => {
      this.isMobile = event.matches;
    });
  },
  
  updated() {
    if (this.isAuthenticated) {
      setTimeout(() => {
        //this.fetchUnreadCount();
      }, 1500);
    }
  },
};
</script>



// WEBPACK FOOTER //
// Header.vue?4432bc8e